import Joi from 'joi';
import { rutValidation } from '../../../../../../helpers/RutValidator';

export const schema = Joi.object({
  rut: rutValidation.rut().validateRut(),
  clientName: Joi.string()
    .min(3)
    .error(new Error('Debe ingresar su nombre completo.')),
  phone: Joi.string()
    .min(9)
    .max(9)
    .pattern(new RegExp(/^\d+$/))
    .error(new Error('El teléfono debe contener 9 dígitos.')),
  email: Joi.string()
    .email({ minDomainSegments: 2, tlds: {} })
    .error(new Error('Formato de correo inválido.')),
  newEmail: Joi.string()
    .email({ minDomainSegments: 2, tlds: {} })
    .error(new Error('Formato de correo inválido.')),
  comment: Joi.string()
    .allow(null, '')
    .max(250)
    .error(new Error('Máximo 250 caracteres.')),
});
